import { styled } from 'styled-components';

export const ToolbarButton = styled.span<{ $isActive?: boolean; $fillOnHover?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 24px;
  transition: 0.15s;
  background-color: ${({ $isActive, theme }) => $isActive && theme.colors.grey30_1};
  border-radius: 2px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey30_1};

    path {
      ${({ $fillOnHover, theme }) => ($fillOnHover === false ? '' : `fill: ${theme.colors.black_1} !important`)};
    }
  }
`;
